<template>
    <div>
        <card-header title="Edit Session Group" icon="fa-pencil" />

        <card-body>
            <group-form :group="group" :conf="conference" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteGroup"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Group?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!group.title"
                    ><i class="fas fa-check mr-2"></i>Save Session
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from '@/http_client';
    import moment from "moment";
    import GroupForm from "./GroupForm";
    import async from "async";

    export default {
        components: {GroupForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                group: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadGroup: function (force) {

                this.$emit('loading', true);
                async.parallel([
                    (cb) => {
                        http.get('conferences/' + this.props.confId, {force}).then(response => {
                            response.data.start_at = moment(response.data.start_at).toDate();
                            response.data.end_at = moment(response.data.end_at).toDate();

                            this.conference = response.data;
                            cb();
                        }).catch(err => {

                        });
                    },
                    (cb) => {
                        http.get('conferences/' + this.props.confId + '/groups/' + this.props.groupId, {force: true}).then(response => {
                            response.data.start_at = moment(response.data.start_at).toDate();
                            response.data.end_at = moment(response.data.end_at).toDate();
                            this.group = response.data;
                            cb();

                        }).catch(err => {

                        });
                    },
                ], err => {
                    this.$emit('loading', false);

                });
            },
            submit: function () {
                http.put('conferences/' + this.props.confId + '/groups/' + this.props.groupId, this.group, {force: true}).then(response => {
                    this.$reloadCard('conf-groups');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the session.');
                    this.$emit('loading', false);
                });
            },
            deleteGroup() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('conferences/' + this.props.confId + '/groups/' + this.props.groupId).then(response => {
                        this.$reloadCard('conf-groups');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.groupId': function () {
                this.dirty = null;
                this.loadGroup();
            },
            'session': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this session group? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadGroup();
        }
    };
</script>
